var render = function render(){
  var _vm$employment, _vm$employment$typesT, _vm$employment$typesT2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text page-text--lg mb-8 mb-lg-16"
  }, [_vm._v("직종")]), _c('p', {
    staticClass: "page-text line-height-15"
  }, [_vm._v(_vm._s(((_vm$employment = _vm.employment) === null || _vm$employment === void 0 ? void 0 : (_vm$employment$typesT = _vm$employment.typesTexts) === null || _vm$employment$typesT === void 0 ? void 0 : (_vm$employment$typesT2 = _vm$employment$typesT.join) === null || _vm$employment$typesT2 === void 0 ? void 0 : _vm$employment$typesT2.call(_vm$employment$typesT, "/")) || "-"))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }